import React from "react";
import { useModalSubscriptionCancelHook } from "./modal-subscription-cancel-hooks";

type ContextModalSubscriptionCancel = ReturnType<
  typeof useModalSubscriptionCancelHook
>;
export const ModalSubscriptionCancelContext =
  React.createContext<ContextModalSubscriptionCancel | null>(null);

export function useContextModalSubscriptionCancel() {
  const context = React.useContext(ModalSubscriptionCancelContext);

  if (!context) {
    throw new Error(
      "useContextModalSubscriptionCancel must be used within a ContextModalSubscriptionCancelProvider",
    );
  }

  return context;
}
